var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { userLogin, validateToken } from '@/api/authService';
import ForgotPasswordModal from '@/components/ForgotPassword';
import Modal from '@/components/Modal';
import SocialLogins from '@/components/SocialLogins';
import { useAuth, useConfigContext, useToast } from '@/hoc';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import Button from '../components/common/Button';
import Checkbox from '../components/common/Checkbox';
import InputField from '../components/common/InputField';
import VerifyEmailModal from '@/components/VerifyEmail';
var Login = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, openSignUp = _a.openSignUp, _b = _a.preview, preview = _b === void 0 ? false : _b;
    var _c = useState(false), forgotPassword = _c[0], setForgotPassword = _c[1];
    var _d = useState(false), isLoading = _d[0], setIsLoading = _d[1];
    var _e = useState(false), openVerifyEmailModal = _e[0], setOpenVerifyEmailModal = _e[1];
    var rememberMeStr = localStorage.getItem('rememberMe');
    var rememberMe = rememberMeStr ? JSON.parse(rememberMeStr) : null;
    var _f = useAuth(), login = _f.login, logout = _f.logout;
    var config = useConfigContext().config;
    var _g = useConfigContext().config, logo = _g.logo, userTypeId = _g.userTypeId, userRoleId = _g.userRoleId, groupId = _g.groupId, googleAuth = _g.googleAuth, linkedinAuth = _g.linkedinAuth, forgetPassword = _g.forgetPassword;
    // Dynamically build the options array
    var socialLoginOptions = [
        (googleAuth === null || googleAuth === void 0 ? void 0 : googleAuth.enabled) && 'Google',
        (linkedinAuth === null || linkedinAuth === void 0 ? void 0 : linkedinAuth.enabled) && 'LinkedIn',
    ].filter(Boolean);
    var showToast = useToast().showToast;
    var _h = useForm({
        defaultValues: {
            email: (rememberMe === null || rememberMe === void 0 ? void 0 : rememberMe.email) || '',
            password: (rememberMe === null || rememberMe === void 0 ? void 0 : rememberMe.password) || '',
        },
    }), register = _h.register, handleSubmit = _h.handleSubmit, watch = _h.watch, errors = _h.formState.errors;
    if (!isOpen)
        return null;
    var onSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var loginResponse;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    setIsLoading(true);
                    return [4 /*yield*/, userLogin(data.email, data.password, config === null || config === void 0 ? void 0 : config.userTypeId, config === null || config === void 0 ? void 0 : config.loginRoute)];
                case 1:
                    loginResponse = _e.sent();
                    if (loginResponse.status === 'success') {
                        {
                            login({
                                id: (_a = loginResponse.data) === null || _a === void 0 ? void 0 : _a.id,
                                access_token: ((_b = loginResponse.data) === null || _b === void 0 ? void 0 : _b.access_token) || '',
                                refresh_token: ((_c = loginResponse.data) === null || _c === void 0 ? void 0 : _c.refresh_token) || '',
                            });
                            validateToken((_d = loginResponse.data) === null || _d === void 0 ? void 0 : _d.access_token, config === null || config === void 0 ? void 0 : config.validateTokenRoute).then(function (response) {
                                if (response.status === 'success') {
                                    showToast({
                                        message: 'Logged in successfully',
                                        status: 'success',
                                    });
                                    onClose();
                                    if (data === null || data === void 0 ? void 0 : data.rememberMe) {
                                        localStorage.setItem('rememberMe', JSON.stringify(data));
                                    }
                                }
                                else {
                                    showToast({
                                        message: 'Invalid Credentials',
                                        status: 'error',
                                    });
                                    logout();
                                }
                            });
                        }
                    }
                    else if (loginResponse.message === 'Email not verified') {
                        setOpenVerifyEmailModal(true);
                        showToast({
                            message: loginResponse.message,
                            status: 'info',
                        });
                    }
                    else {
                        showToast({
                            message: loginResponse.message,
                            status: 'error',
                        });
                        logout();
                    }
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs("div", { children: [openVerifyEmailModal && (_jsx(VerifyEmailModal, { email: watch('email'), isOpen: openVerifyEmailModal, onClose: function () {
                    setOpenVerifyEmailModal(false);
                    logout();
                }, onEmailVerify: function () { return setOpenVerifyEmailModal(false); } })), forgotPassword && (_jsx(ForgotPasswordModal, { emailOrMobile: watch('email'), onClose: function () { return setForgotPassword(false); }, isOpen: forgotPassword })), _jsx(Modal, { isOpen: isOpen, onClose: onClose, title: 'Welcome Back!', subTitle: 'Please enter your login details and stay connected.', logoClassName: 'vas-max-h-32', logoSrc: logo === null || logo === void 0 ? void 0 : logo.mobileLoginPageLogo, preview: preview, footer: !(config === null || config === void 0 ? void 0 : config.SignUpOptions) && (_jsxs("div", { className: 'vas-text-vastypographyLabelsFontSize vas-font-vastypographyLabelsFontWeight vas-mt-2', children: ["Don't have an account?", _jsx("div", { onClick: openSignUp, className: 'vas-text-primary vas-hover:underline vas-font-vastypographyLabelsFontWeight vas-inline vas-cursor-pointer vas-ml-2', children: "Sign Up" })] })), children: _jsxs("div", { children: [_jsxs("div", { className: "vas-relative vas-flex vas-flex-col vas-justify-center vas-gap-3 vas-items-center ".concat(socialLoginOptions.length > 0 ? 'vas-border-b vas-pb-6 vas-pt-2 vas-mb-2' : ''), children: [_jsx(SocialLogins, { socialLoginOptions: socialLoginOptions, onSuccess: function () {
                                        onClose();
                                    } }), socialLoginOptions.length > 0 && (_jsx("div", { className: 'vas-text-center vas-text-vastypographyLabelsFontSize vas-text-vastypographyLabelsTextColor vas-absolute vas-bottom-[-10px] vas-bg-white vas-px-3', children: "Or login with" }))] }), _jsxs("form", { onSubmit: handleSubmit(onSubmit), className: 'vas-w-full vas-flex vas-flex-col vas-gap-4', children: [_jsx(InputField, __assign({ type: 'email', placeholder: 'Enter your Email ID' }, register('email', {
                                    required: 'Email is required',
                                    pattern: {
                                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                        message: 'Invalid email address',
                                    },
                                }), { error: errors.email, required: true, inputClass: 'vas-w-full vas-p-2 vas-border vas-rounded-lg focus:vas-outline-none', label: 'Email ID', labelClass: 'vas-block vas-text-vastypographyLabelsTextColor vas-text-vastypographyLabelsFontSize vas-font-vastypographyLabelsFontWeight' })), _jsx(InputField, __assign({ type: 'password', label: 'Password', secondaryAction: forgetPassword ? (_jsx(Button, { className: 'vas-hover:underline !vas-bg-transparent vas-text-primary', onClick: function () {
                                            setForgotPassword(true);
                                        }, children: "Forgot Password?" })) : null, required: true, inputClass: 'vas-w-full vas-p-2 vas-border vas-rounded-lg focus:vas-outline-none', labelClass: 'vas-block vas-text-vastypographyLabelsTextColor vas-text-vastypographyLabelsFontSize vas-font-vastypographyLabelsFontWeight', placeholder: 'Enter your Password' }, register('password', {
                                    required: 'Password is required',
                                    minLength: {
                                        value: 8,
                                        message: 'Password must be at least 8 characters long',
                                    },
                                }), { error: errors.password })), _jsx("div", { className: 'vas-flex vas-items-center', children: _jsx(Checkbox, __assign({ id: 'rememberMe', label: 'Remember me on this computer' }, register('rememberMe'), { labelClass: "vas-ml-2 vas-text-vastypographyLabelsTextColor vas-text-vastypographyLabelsFontSize vas-font-vastypographyLabelsFontWeight", inputClass: 'vas-w-4 vas-h-4 vas-text-primary vas-border-vastypographyLabelsTextColor/30 vas-rounded vas-focus:ring-primary vas-accent-vasAccent' })) }), _jsx(Button, { isLoading: isLoading, type: 'submit', className: 'vas-w-full vas-text-white vas-py-2 vas-rounded-lg vas-text-vastypographyHeadingFontSize vas-font-vastypographyHeadingFontWeight vas-hover:bg-primary vas-shadow-md vas-shadow-primary/30 vas-bg-primary', children: "Login" })] })] }) })] }));
};
export default Login;
